import { eventsApi } from "@/api";
import { routesApp } from "@/constans/routes";
import { useAuth } from "@/store/useAuth";
import { SignUpDesign, useSignUpDesign } from "@/store/useSignUpDesign";
import { callYaMetrika } from "@/utils/call-ya-metrika";
import { useEffect } from "react";
import { generatePath, useNavigate } from "react-router-dom";

export const useIntroRedirects = (analyticsScreenLabel: string) => {
    const { user, emptyFields, getUser, profileWasRemovedError } = useAuth((state) => state);
    const navigate = useNavigate();
    const {
        design: signUpScreen,
        setDesign
    } = useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    useEffect(() => {
        let path: string | null = null;

        if (
            emptyFields() ||
            profileWasRemovedError
        ) {
            // Ничего не делаем, если есть незаполненные поля
            eventsApi.updateUserEvent('start_screen');
            callYaMetrika('first_screen_loaded', {
                first_screen: analyticsScreenLabel
            });
            return;
        }

        if (
            getUser()
                ?.state
            === 'incomplete'
        ) {
            // Если пользователь не завершил регистрацию
            path = generateSignUpPath();
        } else {
            // Если пользователь завершил регистрацию
            path = generatePath(routesApp.browse);
        }

        if (path) {
            navigate(path, { replace: true });
        }
    }, [emptyFields, navigate, user]);
}
